import type { CarrierPurchasingOption } from "@/api/carriers";

export function discoverySourceLabels(options: CarrierPurchasingOption[]) {
  return new Map(
    options.map((option, index) => [
      option.id,
      `${option.apiProvider?.name ?? "EZX rate tables"} — option ${index + 1}`,
    ])
  );
}
